/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * ログインユーザーの権限リクエスト
 * @export
 * @interface PrivilegesRequest
 */
export interface PrivilegesRequest {
    /**
     * consoleログイン時に指定するID
     * @type {string}
     * @memberof PrivilegesRequest
     */
    consoleUserId: string;
}

export function PrivilegesRequestFromJSON(json: any): PrivilegesRequest {
    return PrivilegesRequestFromJSONTyped(json, false);
}

export function PrivilegesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivilegesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'consoleUserId': json['console_user_id'],
    };
}

export function PrivilegesRequestToJSON(value?: PrivilegesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'console_user_id': value.consoleUserId,
    };
}


